var styleDataHash = "0b3127ea";
const injectCss = () => {
  var css = `.PAS9N,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.MRKBq{color:var(--ricos-settings-text-color,#000);width:100%}[dir] .MRKBq{background-color:#fff}.MRKBq._7Tpou{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.MRKBq{height:47px}}}@container (width < 640px){.MRKBq{height:47px}}.MRKBq .ZWS9-{align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px;grid-gap:12px}[dir=ltr] .MRKBq .ZWS9-,[dir=rtl] .MRKBq .ZWS9-{padding-left:20px;padding-right:20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.MRKBq .ZWS9-.pDHdK{grid-auto-columns:auto}}}@container (width < 640px){.MRKBq .ZWS9-.pDHdK{grid-auto-columns:auto}}.MRKBq .ZWS9- ._6Kkhd{align-self:left}@supports not (contain:inline-size){@media only screen and (max-width:640px){.MRKBq .ZWS9- ._6Kkhd{display:flex;width:100%}}}@container (width < 640px){.MRKBq .ZWS9- ._6Kkhd{display:flex;width:100%}}.MRKBq .ZWS9- .iuyTq{display:grid;grid-auto-flow:row}.MRKBq .ZWS9- .iuyTq .MXVuH{font-size:14px}.MRKBq .ZWS9- .iuyTq .Pt7-5{color:#646464;font-size:12px}.MRKBq .ZWS9- .lQTun{align-self:right}.MRKBq:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.MRKBq._7Tpou,.MRKBq:active{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .MRKBq._7Tpou,[dir] .MRKBq:active{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.MRKBq._7Tpou svg,.MRKBq:active svg{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .MRKBq:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.05);cursor:pointer}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_select_default = {
  "fontElementMap": "PAS9N",
  "container": "MRKBq",
  "selected": "_7Tpou",
  "content": "ZWS9-",
  "content_mobile_alignCenter": "pDHdK",
  "prefix": "_6Kkhd",
  "titleWrapper": "iuyTq",
  "title": "MXVuH",
  "subtitle": "Pt7-5",
  "suffix": "lQTun"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
